import bear from '../../assets/images/profile-icons/bear.svg';
import pinkheart from '../../assets/images/profile-icons/pinkheart.svg';
import triplets from '../../assets/images/profile-icons/triplets.svg';
import tulip from '../../assets/images/profile-icons/tulip.svg';
import twins from '../../assets/images/profile-icons/twins.svg';

export default {
  bear,
  pinkheart,
  triplets,
  tulip,
  twins
};



// WEBPACK FOOTER //
// ./src/components/icons/profileIcons.js